import type { BootstrapSecretLease } from "./bootstrapSecret";
import { bootstrapSecretLease } from "./bootstrapSecret";
import type { ForgeRemoteApi, ForgeRemoteDataSourceKind } from "./contracts";
import { FixtureForgeRemoteApi } from "./fixtureApi";
import { PortalForgeRemoteApi } from "./portalApi";

export const DEVELOPMENT_SOURCE_QUERY_KEY = "forgeRemoteDevSource";

export function selectForgeRemoteDataSource(isDevelopment: boolean, search: string): ForgeRemoteDataSourceKind {
  if (!isDevelopment) return "portal";
  const requested = new URLSearchParams(search).get(DEVELOPMENT_SOURCE_QUERY_KEY);
  return requested === "fixture" ? "development-fixture" : "portal";
}

export interface ForgeRemoteRuntime {
  sourceKind: ForgeRemoteDataSourceKind;
  api: ForgeRemoteApi;
}

interface RuntimeOptions {
  isDevelopment: boolean;
  search: string;
  origin?: string;
  fetch?: typeof fetch;
  bootstrapSecret?: BootstrapSecretLease;
  readCookie?: () => string;
}

export function createForgeRemoteRuntime(options: RuntimeOptions): ForgeRemoteRuntime {
  const sourceKind = selectForgeRemoteDataSource(import.meta.env.DEV && options.isDevelopment, options.search);
  const api = sourceKind === "development-fixture"
    ? new FixtureForgeRemoteApi(options.search)
    : new PortalForgeRemoteApi({
        origin: options.origin,
        fetch: options.fetch,
        bootstrapSecret: options.bootstrapSecret ?? bootstrapSecretLease,
        readCookie: options.readCookie,
      });
  return { sourceKind, api };
}

export type {
  ActivationPreview,
  ActivationRedemption,
  BoardEditRequest,
  CommandRequest,
  ForgeRemoteApi,
  ManagerMessageRequest,
  OperationReceipt,
  ProjectionEnvelope,
  ProjectionStreamOptions,
} from "./contracts";
